import * as Sentry from '@sentry/react'
import { interceptConsole } from 'loggers/interceptConsole'

const NEEDLE = 'This can lead to unnecessary rerenders.'

// const seen = new Set<string>()

export function installReduxSelectorWarningForwarder() {
  if (window.ENV === 'production' || window.ENV === 'local') return

  return interceptConsole({
    methods: ['warn'],
    sampleRate: 1,
    match(args) {
      return typeof args[0] === 'string' && args[0].includes(NEEDLE)
    },
    onMatch(args) {
      const details = args.find((a) => a && typeof a === 'object') as any

      // if (seen.has(key)) return
      // seen.add(key)

      const err = new Error('React render stability check failed')
      if (details?.stack) err.stack = String(details.stack)

      Sentry.captureException(err, {
        level: 'warning',
        tags: {
          source: 'react-render',
          check: 'stabilityCheck',
        },
        extra: {
          consoleArgs: args,
          details,
          href: window.location.href,
        },
      })
    },
  })
}
